import { FormattedMessage } from 'react-intl'

const Exchanges = () => {
  return (
    <div>
      <FormattedMessage id="exchanges.page.title" defaultMessage="Exchanges" />
    </div>
  )
}

export default Exchanges
